
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
  @Component
export default class BaseInfo extends Vue {
    @Prop() student_info_id: string
    @Prop() is_show_student_info: boolean
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    studentId: any = ''
    studentDetailObj: any = {} // 学生详情
    textEdit: string = '修改'
    textSave: string = '保存'
    textIndex: number = 0
    remarkList: any = [] // 签到记录
    alertCreateRemark: boolean = false // 创建弹窗
    levelName: string = '' // 学员等级
    instrument: any = [] // 乐器类型
    is_teach_plan: number = 1 // 教学计划
    capability: number = 0 // 能力值是否可见
    ableList: any = [] // 能力值
    has_comment: string = '' // 是否点评
    is_enabled: string = '' // 是否可约课
    is_end: string = '' // 是否结课
    is_locked: number = 0// 是否冻结
    dialogAddZy: boolean = false // 冻结文案弹窗
    campus: any = []
    employee: any = []
    campus_id: string = ''
    form: any = {
      name: '丁老师',
      region: '1',
      date1: '',
      date2: '',
      delivery: false,
      type: [],
      resource: '',
      desc: ''
    }
    ableStatus: any = {
      1: '未开始',
      2: '进行中',
      3: '已完成',
      4: '已跳过'
    }
    action: boolean = false

    async mounted() {
      this.getStudentDetail() // 学生详情
      this.action = true
    }
    @Watch('is_show_student_info')
    getDetails(oldVal, newVal) {
      if(this.is_show_student_info) {
        this.getStudentDetail() // 学生详情
        this.action = true
      }
    }

    async update(data) {
      data.student_id = this.student_info_id
      const res: any = await CourseModule.studentUpdate(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.getStudentDetail()
      } else {
        this.$message.error(res.message)
      }
    }
    showContent(val) {
      for(var i = 0; i < this.ableList.length; i++) {
        if(val.subject_id != this.ableList[i].subject_id) {
          Vue.set(this.ableList[i], 'flag', false)
        }
      }
      if(val.flag === true) {
        Vue.set(val, 'flag', false)   
      } else {
        Vue.set(val, 'flag', true)   
      }
    }

    allClick() {
      for(var i = 0; i < this.ableList.length; i++) {
        Vue.set(this.ableList[i], 'flag', false)
      }
    }
    infoClick() {}

    async getStudentDetail() {
      const res = await CourseModule.studentDetail({ 'student_id': this.student_info_id })
      this.studentDetailObj = res.data
      this.ableList = this.studentDetailObj.able
      for(var i = 0; i < this.ableList.length; i++) {
        Vue.set(this.ableList[i], 'flag', false)
      }
      this.ableList = this.studentDetailObj.able
      this.campus_id = this.studentDetailObj.campus_id
      this.capability = this.studentDetailObj.show_student_value
      this.remarkList = this.studentDetailObj.remark_list
      this.is_teach_plan = this.studentDetailObj.is_teach_plan
      this.levelName = this.studentDetailObj.level_id
      this.is_locked = this.studentDetailObj.is_locked
      this.has_comment = this.studentDetailObj.has_comment
      this.is_enabled = this.studentDetailObj.is_enabled
      this.is_end = this.studentDetailObj.is_end

      this.$emit('get-details', res.data)
    }

}
